// A CANCELLED form is either one the system cancelled because the customer
// submitted again, or one a staff member cancelled (cancelled_by_admin_id set).
export const SELL_AND_RENT_CANCELLED_BY_ADMIN_LABEL =
  "รายการถูกยกเลิกโดยเจ้าหน้าที่";

export const SellAndRentStatus = {
  WAITING_FOR_AUTHORITY: "อยู่ในระหว่างเจ้าหน้าที่ติดต่อกลับ",
  LOOKING_FOR_RENTERS: "ดำเนินการหาผู้ซื้อและ (หรือ) ผู้เช่า",
  COMPLETED: "ขาย หรือ ปล่อยเช่า เรียบร้อย",
  CANCELLED: "รายการถูกยกเลิก เนื่องจากลูกค้าแก้ไขข้อมูล",
  ADMIN_CANCELLED: SELL_AND_RENT_CANCELLED_BY_ADMIN_LABEL,
  USER_CANCELLED: "รายการถูกยกเลิกโดยผู้ใช้งาน",
};

export const SellAndRentStatusEnum = {
  WAITING_FOR_AUTHORITY: "WAITING_FOR_AUTHORITY",
  LOOKING_FOR_RENTERS: "LOOKING_FOR_RENTERS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  ADMIN_CANCELLED: "ADMIN_CANCELLED",
  USER_CANCELLED: "USER_CANCELLED",
};

// Values the list filter sends but the API never returns as a form status: a
// form an admin cancelled still has status CANCELLED.
export const SellAndRentFilterOnlyStatuses = [
  SellAndRentStatusEnum.ADMIN_CANCELLED,
];

export function getSellAndRentStatusLabel(status, cancelledByAdmin) {
  if (status === SellAndRentStatusEnum.CANCELLED && cancelledByAdmin) {
    return SELL_AND_RENT_CANCELLED_BY_ADMIN_LABEL;
  }

  return SellAndRentStatus[status];
}

// Dropdown-only action, not a real form status: picking it cancels the form
// instead of moving it along the status progression.
export const SELL_AND_RENT_ADMIN_CANCEL = "ADMIN_CANCEL";
export const SELL_AND_RENT_ADMIN_CANCEL_LABEL = "ยกเลิกรายการโดยเจ้าหน้าที่";
